<template>
  <div>
    <CashflowSelect @updated="updated" />
    <h1>Purposes</h1>
    <v-btn @click="editPurpose">
      <v-icon>add</v-icon>Purpose
    </v-btn>
    <table border="1">
      <tr>
        <th>Body</th>
        <th />
        <th />
      </tr>
      <tr v-for="purpose in purposes" :key="purpose.id">
        <td>{{purpose.body}}</td>
        <td>
          <a @click="editPurpose(purpose)">Edit</a>
        </td>
        <td>
          <a @click="deletePurpose(purpose)">Delete</a>
        </td>
      </tr>
    </table>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      v-if="purpose"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Edit purpose</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form>
            <p>Edit this purpose entry</p>
            <v-text-field label="Body" v-model="purpose.body" outline />
            <v-btn @click="savePurpose">
              <v-icon>save</v-icon>Save
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CashflowSelect from "@/components/cashflow/CashflowSelect";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Purposes",
  metaInfo() {
    return {
      title: "Purposes",
      titleTemplate: "%s - Cashflow - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { CashflowSelect },
  data() {
    return { purposes: null, purpose: null, dialog: false };
  },
  methods: {
    fetchPurposes() {
      nbmlaw
        .get(`/cors/admin/cashflow/purposes`)
        .then(response => {
          // console.log(response.data);
          this.purposes = response.data;
        })
        .catch(() => {});
    },
    editPurpose(purpose) {
      this.purpose = purpose ? purpose : {};
      this.dialog = true;
    },
    savePurpose() {
      if (this.purpose.id) {
        this.updatePurpose();
      } else {
        this.createPurpose();
      }
    },
    createPurpose() {
      nbmlaw
        .post(`/cors/admin/cashflow/purposes`, this.purpose)
        .then(() => {
          // console.log(response.data);
          this.fetchPurposes();
          this.dialog = false;
        })
        .catch(() => {});
    },
    updatePurpose() {
      nbmlaw
        .put(`/cors/admin/cashflow/purposes/${this.purpose.id}`, this.purpose)
        .then(() => {
          // console.log(response.data);
          this.fetchPurposes();
          this.dialog = false;
        })
        .catch(() => {});
    },
    deletePurpose(purpose) {
      if (confirm("Are you sure?")) {
        nbmlaw
          .delete(`/cors/admin/cashflow/purposes/${purpose.id}`)
          .then(() => {
            // console.log(response.data);
            this.fetchPurposes();
          })
          .catch(() => {});
      }
    },
    updated() {
      this.fetchPurposes();
    }
  },
  created() {
    this.fetchPurposes();
  }
};
</script>
